import { LoadingRedoUndoOutlined } from "@aircall/icons";
import { Button, Icon } from "@aircall/tractor";
import { useTranslation } from "react-i18next";

import { SubmitButtonProps } from ".";

export function SubmitButton({
  loading = false,
  children,
  loadingLabel,
  ...props
}: SubmitButtonProps) {
  const { t } = useTranslation();
  const content = children ?? t("submit");
  return (
    <Button data-test="submit-button" type="submit" {...props}>
      {loading ? (
        <>
          <Icon data-test="loader" spin component={LoadingRedoUndoOutlined} />
          {loadingLabel ?? t("submitting")}
        </>
      ) : (
        content
      )}
    </Button>
  );
}
